// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.individual-client-container .header-container {
  min-height: auto;
}
.individual-client-container .dashboard-container {
  padding-left: 0;
  padding-bottom: 0;
}
.individual-client-container .chart-bg {
  background: none !important;
}
.individual-client-container .simulate-container {
  padding-top: 25px !important;
  display: flex;
}
.individual-client-container .indiv-wrapper {
  border-radius: 8px;
  max-height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
}
.individual-client-container .chrono-tabs-container {
  background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);
  margin: 15px 0px 0px 0px;
  padding: 10px;
}
.individual-client-container .chrono-tabs-container .chrono-list-wrapper {
  display: flex;
  list-style: none;
  color: white;
  font-size: 12px;
  border: none;
  padding: 0px;
}
.individual-client-container .chrono-tabs-container .chrono-list-wrapper .border-div {
  margin-bottom: 4px;
}
.individual-client-container .chrono-tabs-container .chrono-tab {
  width: 150px;
  text-align: center;
}
.individual-client-container .chrono-tabs-container .chrono-list {
  cursor: pointer;
  padding: 0px 10px;
  font-size: 12px;
  color: #ffffff;
  line-height: 14.06px;
}
.individual-client-container .chrono-tabs-container .chrono-list .chrono-list-icon {
  color: #ffffff;
}
.individual-client-container .chrono-tabs-container .chrono-list-current {
  color: #ffffff;
  font-weight: bold;
  border-radius: 8px;
}
.individual-client-container .chrono-tabs-container .chrono-list-current > div {
  border-bottom: 2px solid white;
  padding-bottom: 4px;
}
.individual-client-container .chrono-tabs-container .chrono-list-current .label {
  color: #009fe3;
}
.individual-client-container .chrono-tabs-container .chrono-list-current .chrono-list-icon {
  height: 28px;
  width: 28px;
  border-radius: 50%;
  color: #ffffff;
  background-color: none;
}
.individual-client-container .chrono-content-container {
  background: rgba(255, 255, 255, 0.3);
  border: 2px solid #ffffff;
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
  min-height: 62px;
  margin: 15px 0px 0px 0px;
  padding: 10px;
}
.individual-client-container .chrono-content-container .chrono-list-wrapper {
  display: flex;
  list-style: none;
  color: white;
  font-size: 12px;
  padding: 0px;
  border: none;
}
.individual-client-container .chrono-content-container .chrono-list {
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  line-height: 35px;
  color: #1e106b;
}
.individual-client-container .chrono-content-container .chrono-list .chrono-sub-header {
  margin-left: 5px;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 35px;
  color: #1e106b;
}
.individual-client-container .chrono-content-container .chrono-list .chrono-list-icon {
  height: 28px;
  width: 28px;
  border-radius: 50%;
  color: #ffffff;
}
.individual-client-container .chrono-content-container .chrono-content-items {
  align-items: center;
  list-style: none;
  padding-left: 5px;
}
.individual-client-container .chrono-content-container .chrono-content-items .chrono-item {
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 1px 0px;
  font-weight: normal;
  font-size: 14px;
  line-height: 35px;
  color: #000000;
  padding: 2px;
}
.individual-client-container .chrono-content-container .chrono-content-items .chrono-item .chrono-wrapper {
  display: flex;
  justify-content: space-between;
}
.individual-client-container .chrono-content-container .chrono-content-items .chrono-item .chrono-label {
  font-size: 13px;
  color: #555555;
  padding: 1px;
  margin-left: 5px;
}
.individual-client-container .chrono-content-container .chrono-content-items .chrono-item .chrono-value {
  font-size: 13px;
  color: black;
  justify-content: flex-end;
  margin-right: 8px;
}
.individual-client-container .chrono-content-container .chrono-content-items .chrono-item .chrono-label-no-tooltip {
  padding: 1px;
  font-size: 13px;
  color: #555555;
}
.individual-client-container .chrono-content-container .chrono-content-items .chrono-item .chrono-label-no-tooltip:hover {
  background: rgba(203, 249, 255, 0.5);
  border: 1px dashed #009fe3;
  box-sizing: border-box;
  box-shadow: 0px 0px 23px rgba(2, 209, 255, 0.3);
  border-radius: 2px 10px 10px 10px;
}
.individual-client-container .output-tab {
  width: 100%;
  padding: 0 !important;
  text-align: center;
}
.individual-client-container .output-tab-current .list-item-label {
  border-bottom: 2px solid white;
  padding-bottom: 2px;
}
.individual-client-container .planner-tabs-wrapper {
  width: 100%;
  padding-top: 20px;
}
.individual-client-container .planner-tabs-wrapper .MuiPaper-root {
  box-shadow: none;
  border-radius: 10px;
}
.individual-client-container .planner-tabs-wrapper .planner-tab-panel {
  margin-top: 8px;
  border: 2px solid #ffffff;
  border-radius: 10px;
}
.individual-client-container .planner-tabs-wrapper .accordion-container .MuiAccordion-root {
  background: #e0e0e0;
}
.individual-client-container .planner-tabs-wrapper .accordion-container .MuiAccordionSummary-content {
  margin: 4px 0;
}
.individual-client-container .planner-tabs-wrapper .accordion-container .MuiAccordionSummary-root {
  background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);
  border: 2px solid #ffffff;
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
}
.individual-client-container .planner-tabs-wrapper .accordion-container .MuiAccordionDetails-root {
  background: #e0e0e0;
  padding: 8px 0;
}
.individual-client-container .planner-tabs-wrapper .accordion-container .MuiSvgIcon-root {
  color: #ffffff;
}
.individual-client-container .planner-tabs-wrapper .tabs-container {
  background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);
  border-radius: 10px;
  border: 2px solid #ffffff;
  padding: 10px;
}
.individual-client-container .planner-tabs-wrapper .tabs-container .MuiTab-root {
  font-size: 12px;
  color: white;
  min-height: 30px;
  height: 40px;
}
.individual-client-container .planner-tabs-wrapper .tabs-container .Mui-selected {
  font-weight: bold;
}
.individual-client-container .planner-tabs-wrapper .tabs-container .Mui-selected .MuiTouchRipple-root {
  border-bottom: 2px solid #ffffff;
}
.individual-client-container .form-container {
  margin-left: 20px;
  font-size: 12px;
  padding: 10px 10px 10px 0;
}
.individual-client-container .form-container .empty-grid {
  border-left: 1px solid #ffffff;
}
.individual-client-container .form-container .empty-grid:last-child {
  border-right: 1px solid #ffffff;
}
.individual-client-container .form-container .fields-list-container {
  display: flex;
  list-style: none;
  border-top: 1px solid #ffffff;
  border-left: 1px solid #ffffff;
  border-right: 1px solid #ffffff;
}
.individual-client-container .form-container .fields-list-container .fields-list-item {
  font-size: 12px;
  text-align: center;
  padding: 4px;
  border-left: 1px solid #ffffff;
}
.individual-client-container .form-container .fields-list-container .fields-list-item:last-child {
  border-right: 1px solid #ffffff;
}
.individual-client-container .form-container .member-list-container {
  border-top: 1px solid #ffffff;
  border-left: 1px solid #ffffff;
  border-right: 1px solid #ffffff;
}
.individual-client-container .form-container .member-list-container:last-child {
  border-bottom: 1px solid #ffffff;
}
.individual-client-container .form-container .member-list-container .member-name {
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  padding: 8px;
}
.individual-client-container .form-container .common-list-container {
  border-bottom: 1px solid #ffffff;
}
.individual-client-container .form-container .common-list-container .common-title {
  padding: 8px;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
}
.individual-client-container .form-container .planner-input {
  border-radius: 8px;
  border: 0.5px solid #61b76e;
  width: 100%;
  height: 30px;
  padding: 4px;
}
.individual-client-container .form-container .planner-input:focus-visible {
  outline: none;
}
.individual-client-container .form-container .planner-input-hide {
  opacity: 0;
  height: 0;
  width: 0;
}
.individual-client-container .form-container .planner-input-show {
  opacity: 1;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
}
.individual-client-container .form-container .planner-input-show svg {
  vertical-align: middle;
}
.individual-client-container .form-container .planner-input-show .select {
  width: 80%;
  border-color: #61b76e;
  border-radius: 8px;
  padding: 4px 0;
}
.individual-client-container .form-container .planner-input-grid {
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  text-align: center;
  border-left: 1px solid #ffffff;
}
.individual-client-container .form-container .planner-input-grid:last-child {
  border-right: 1px solid #ffffff;
}
.individual-client-container .form-container .planner-input-grid > div {
  padding: 8px;
  margin-bottom: 8px;
  border-radius: 10px;
}
.individual-client-container .form-container .planner-input-grid .planner-label-disabled {
  background-color: lightgray;
}
.individual-client-container .form-container .planner-input-grid .error-text {
  padding: 0;
  margin: 0;
  font-size: 10px;
  color: red;
}
.individual-client-container .form-container .planner-input-grid .error-field {
  border-color: red;
}
.individual-client-container .form-container .planner-input-grid .input-value {
  border-radius: 45px 50px 5px 50px;
  color: white;
  padding: 5px 5px;
  background: linear-gradient(180.61deg, #32a3b2 29.35%, #61b76e 90.9%);
  font-size: 11px;
  text-align: center;
  margin-top: 8px;
  margin-right: 5px;
  margin-bottom: 5px;
  display: inline;
}
.individual-client-container .feedback-button {
  padding: 4px 2px 0;
  max-width: fit-content;
}
.individual-client-container .feedback-button button {
  background-color: #fbc02d;
  padding: 5px;
  border-radius: 4px;
  height: 25px;
  text-transform: none;
}
.individual-client-container .feedback-button button .MuiButton-startIcon {
  margin: 0;
}
.individual-client-container .feedback-button button .MuiButton-iconSizeMedium {
  margin-right: 4px;
}
.individual-client-container .simulate-buttons {
  padding: 4px 2px 0;
  max-width: fit-content;
  margin-top: 4px !important;
}
.individual-client-container .simulate-buttons button {
  background-color: #009fe3;
  padding: 4px;
  border-radius: 8px;
  height: 25px;
  color: white;
}
.individual-client-container .simulate-buttons button .MuiButton-startIcon {
  margin: 0;
}
.individual-client-container .simulate-buttons button .MuiButton-iconSizeMedium {
  margin-right: 0;
}
.individual-client-container .chrono-container {
  width: 100%;
}
.individual-client-container .chrono-container .chrono-tabs-wrapper {
  background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);
  border: 2px solid #ffffff;
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
  min-height: 62px;
  margin: 15px 0px 0px 0px;
  padding: 10px;
}
.individual-client-container .chrono-container .chrono-parent-tab .MuiTabs-root {
  border-bottom: 1px solid #e0e0e0;
  min-height: 30px;
}
.individual-client-container .chrono-container .chrono-parent-tab .MuiTab-root {
  font-size: 12px;
  color: white;
  min-height: 30px;
  height: 40px;
}
.individual-client-container .chrono-container .chrono-parent-tab .Mui-selected {
  font-weight: bold;
}
.individual-client-container .chrono-container .chrono-parent-tab .Mui-selected .MuiTouchRipple-root {
  border-bottom: 2px solid #ffffff;
}
.individual-client-container .chrono-container .chrono-sub-tab {
  margin: 4px 16px;
}
.individual-client-container .chrono-container .chrono-sub-tab .MuiTab-root {
  font-size: 10px;
  color: white;
  min-height: 30px;
  height: 40px;
}
.individual-client-container .chrono-container .chrono-sub-tab .Mui-selected {
  font-weight: bold;
}
.individual-client-container .chrono-container .chrono-sub-tab .Mui-selected .MuiTouchRipple-root {
  border-bottom: 2px solid #ffffff;
}
.individual-client-container .chrono-container .faq-wrapper {
  border: 2px solid #ffffff;
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
  margin: 15px 0px 0px 0px;
  padding: 10px;
}
.individual-client-container .chrono-container .faq-wrapper .chrono-tabs-container {
  width: 100%;
  border: 2px solid #ffffff;
  border-radius: 10px;
  padding: 0;
  margin-top: 8px;
}
.individual-client-container .chrono-container .faq-wrapper .item-width {
  max-width: 100%;
  flex-basis: 100%;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child {
  margin: 8px 0;
  min-height: 25px;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul {
  display: inline-flex;
  list-style: none;
  padding: 0 8px 0 0;
  margin: 0;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul > li {
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  padding: 2px 2px 3px 2px;
  background-color: #ffffff;
  margin-right: 8px;
  display: flex;
  cursor: pointer;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul > li .child-item {
  margin-right: 14px;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul > li .child-item .MuiRadio-root {
  padding: 0;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul > li .member-item {
  padding: 1px 8px 0;
  cursor: pointer;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul > li .member-item label {
  cursor: pointer;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul > li .member-item .member-editable-label {
  font-size: 12px;
  padding-top: 4px;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul > li .member-item .editing-text {
  border: 1px solid white;
  border-radius: 8px;
  padding: 2px 4px;
  outline: none;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul .selected-child {
  background-color: #009fe3;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul .selected-child label {
  color: white;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul .selected-child svg {
  color: white;
}
.individual-client-container .chrono-container .faq-wrapper .planner-add-child ul .selected-child .member-editable-label {
  color: white;
}
.individual-client-container .chrono-container .faq-wrapper .faq-container {
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 5px;
  padding: 5px;
}
.individual-client-container .chrono-container .faq-wrapper .faq-container .faq-content-items .faq-item {
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 1px 0px;
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  color: #000000;
  padding: 2px;
}
.individual-client-container .chrono-container .faq-wrapper .faq-container .faq-content-items .faq-item .faq-question {
  font-size: 13px;
  color: #555555;
}
.individual-client-container .chrono-container .faq-wrapper .faq-container .faq-content-items .faq-item .faq-answer {
  font-size: 13px;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/styles/individualClient.scss"],"names":[],"mappings":"AAEE;EACE,gBAAA;AADJ;AAGE;EACE,eAAA;EACA,iBAAA;AADJ;AAGE;EACE,2BAAA;AADJ;AAGE;EACE,4BAAA;EACA,aAAA;AADJ;AAGE;EAEE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;AAIE;EACE,6DAAA;EAEA,wBAAA;EACA,aAAA;AAHJ;AAII;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AAFN;AAGM;EACE,kBAAA;AADR;AAII;EACE,YAAA;EACA,kBAAA;AAFN;AAII;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AAFN;AAIM;EACE,cAAA;AAFR;AAIM;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AAFR;AAGQ;EACE,8BAAA;EACA,mBAAA;AADV;AAGQ;EACE,cAAA;AADV;AAGQ;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;AADV;AAME;EACE,oCAAA;EACA,yBAAA;EACA,sBAAA;EACA,gDAAA;EACA,mBAAA;EAEA,gBAAA;EACA,wBAAA;EACA,aAAA;AALJ;AAQI;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AANN;AAQI;EACE,eAAA;EAEA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,cAAA;AARN;AAWM;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATR;AAWM;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AATR;AAaI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAXN;AAYM;EACE,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAVR;AAWQ;EACE,aAAA;EACA,8BAAA;AATV;AAWQ;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AATV;AAWQ;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;AATV;AAWQ;EACE,YAAA;EACA,eAAA;EACA,cAAA;AATV;AAUU;EACE,oCAAA;EACA,0BAAA;EACA,sBAAA;EACA,+CAAA;EACA,iCAAA;AARZ;AAcE;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;AAZJ;AAcM;EACE,8BAAA;EACA,mBAAA;AAZR;AAgBE;EACE,WAAA;EACA,iBAAA;AAdJ;AAeI;EACE,gBAAA;EACA,mBAAA;AAbN;AAeI;EACE,eAAA;EACA,yBAAA;EACA,mBAAA;AAbN;AAgBM;EACE,mBAAA;AAdR;AAgBM;EACE,aAAA;AAdR;AAgBM;EACE,6DAAA;EACA,yBAAA;EACA,sBAAA;EACA,gDAAA;EACA,mBAAA;AAdR;AAgBM;EACE,mBAAA;EACA,cAAA;AAdR;AAgBM;EACE,cAAA;AAdR;AAiBI;EACE,6DAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;AAfN;AAgBM;EACE,eAAA;EAEA,YAAA;EACA,gBAAA;EACA,YAAA;AAfR;AAiBM;EACE,iBAAA;AAfR;AAgBQ;EACE,gCAAA;AAdV;AAmBE;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;AAjBJ;AAkBI;EACE,8BAAA;AAhBN;AAiBM;EACE,+BAAA;AAfR;AAkBI;EACE,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;AAhBN;AAiBM;EAEE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;AAhBR;AAiBQ;EACE,+BAAA;AAfV;AAmBI;EAEE,6BAAA;EACA,8BAAA;EACA,+BAAA;AAlBN;AAmBM;EACE,gCAAA;AAjBR;AAmBM;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAjBR;AAoBI;EACE,gCAAA;AAlBN;AAmBM;EACE,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAjBR;AAqBM;EACE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAnBR;AAqBQ;EACE,aAAA;AAnBV;AAqBQ;EACE,UAAA;EACA,SAAA;EACA,QAAA;AAnBV;AAqBQ;EACE,UAAA;EAEA,6BAAA;EACA,qCAAA;AApBV;AAsBU;EACE,sBAAA;AApBZ;AAsBU;EACE,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AApBZ;AA0BI;EACE,sBAAA;EACA,gDAAA;EACA,kBAAA;EACA,8BAAA;AAxBN;AAyBM;EACE,+BAAA;AAvBR;AAyBM;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;AAvBR;AAyBM;EACE,2BAAA;AAvBR;AAyBM;EACE,UAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AAvBR;AAyBM;EACE,iBAAA;AAvBR;AA0BM;EACE,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,qEAAA;EAEA,eAAA;EAEA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA1BR;AA+BE;EACE,kBAAA;EACA,sBAAA;AA7BJ;AA8BI;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;AA5BN;AA6BM;EACE,SAAA;AA3BR;AA6BM;EACE,iBAAA;AA3BR;AA+BE;EACE,kBAAA;EACA,sBAAA;EACA,0BAAA;AA7BJ;AA8BI;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AA5BN;AA6BM;EACE,SAAA;AA3BR;AA6BM;EACE,eAAA;AA3BR;AA+BE;EACE,WAAA;AA7BJ;AA8BI;EACE,6DAAA;EACA,yBAAA;EACA,sBAAA;EACA,gDAAA;EACA,mBAAA;EAEA,gBAAA;EACA,wBAAA;EACA,aAAA;AA7BN;AAgCM;EACE,gCAAA;EACA,gBAAA;AA9BR;AAgCM;EACE,eAAA;EAEA,YAAA;EACA,gBAAA;EACA,YAAA;AA/BR;AAiCM;EACE,iBAAA;AA/BR;AAgCQ;EACE,gCAAA;AA9BV;AAkCI;EACE,gBAAA;AAhCN;AAiCM;EACE,eAAA;EAEA,YAAA;EACA,gBAAA;EACA,YAAA;AAhCR;AAkCM;EACE,iBAAA;AAhCR;AAiCQ;EACE,gCAAA;AA/BV;AAmCI;EACE,yBAAA;EACA,sBAAA;EACA,gDAAA;EACA,mBAAA;EAEA,wBAAA;EACA,aAAA;AAlCN;AAmCM;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;AAjCR;AAmCM;EACE,eAAA;EACA,gBAAA;AAjCR;AAmCM;EACE,aAAA;EACA,gBAAA;AAjCR;AAkCQ;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AAhCV;AAiCU;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AA/BZ;AAgCY;EACE,kBAAA;AA9Bd;AA+Bc;EACE,UAAA;AA7BhB;AAgCY;EACE,kBAAA;EACA,eAAA;AA9Bd;AA+Bc;EACE,eAAA;AA7BhB;AA+Bc;EACE,eAAA;EACA,gBAAA;AA7BhB;AA+Bc;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AA7BhB;AAiCU;EACE,yBAAA;AA/BZ;AAgCY;EACE,YAAA;AA9Bd;AAgCY;EACE,YAAA;AA9Bd;AAgCY;EACE,YAAA;AA9Bd;AAmCM;EACE,sBAAA;EACA,gDAAA;EACA,kBAAA;EACA,YAAA;AAjCR;AAmCU;EACE,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAjCZ;AAkCY;EACE,eAAA;EACA,cAAA;AAhCd;AAkCY;EACE,eAAA;EACA,YAAA;AAhCd","sourcesContent":[".individual-client-container {\r\n  // padding: 20px;\r\n  .header-container {\r\n    min-height: auto;\r\n  }\r\n  .dashboard-container {\r\n    padding-left: 0;\r\n    padding-bottom: 0;\r\n  }\r\n  .chart-bg {\r\n    background: none !important;\r\n  }\r\n  .simulate-container {\r\n    padding-top: 25px !important;\r\n    display: flex;\r\n  }\r\n  .indiv-wrapper {\r\n    // margin-top: 8px;\r\n    border-radius: 8px;\r\n    max-height: 540px;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n  }\r\n  .chrono-tabs-container {\r\n    background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);\r\n    // min-height: 62px;\r\n    margin: 15px 0px 0px 0px;\r\n    padding: 10px;\r\n    .chrono-list-wrapper {\r\n      display: flex;\r\n      list-style: none;\r\n      color: white;\r\n      font-size: 12px;\r\n      border: none;\r\n      padding: 0px;\r\n      .border-div {\r\n        margin-bottom: 4px;\r\n      }\r\n    }\r\n    .chrono-tab {\r\n      width: 150px;\r\n      text-align: center;\r\n    }\r\n    .chrono-list {\r\n      cursor: pointer;\r\n      padding: 0px 10px;\r\n      font-size: 12px;\r\n      color: #ffffff;\r\n      line-height: 14.06px;\r\n\r\n      .chrono-list-icon {\r\n        color: #ffffff;\r\n      }\r\n      &-current {\r\n        color: #ffffff;\r\n        font-weight: bold;\r\n        border-radius: 8px;\r\n        > div {\r\n          border-bottom: 2px solid white;\r\n          padding-bottom: 4px;\r\n        }\r\n        .label {\r\n          color: #009fe3;\r\n        }\r\n        .chrono-list-icon {\r\n          height: 28px;\r\n          width: 28px;\r\n          border-radius: 50%;\r\n          color: #ffffff;\r\n          background-color: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .chrono-content-container {\r\n    background: rgba(255, 255, 255, 0.3);\r\n    border: 2px solid #ffffff;\r\n    box-sizing: border-box;\r\n    box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);\r\n    border-radius: 10px;\r\n    // width: 85%;\r\n    min-height: 62px;\r\n    margin: 15px 0px 0px 0px;\r\n    padding: 10px;\r\n    // max-height: 400px;\r\n    // overflow-y: auto;\r\n    .chrono-list-wrapper {\r\n      display: flex;\r\n      list-style: none;\r\n      color: white;\r\n      font-size: 12px;\r\n      padding: 0px;\r\n      border: none;\r\n    }\r\n    .chrono-list {\r\n      cursor: pointer;\r\n      // padding: 0px 10px;\r\n      font-size: 12px;\r\n      font-weight: bold;\r\n      font-style: normal;\r\n      // text-transform: capitalize;\r\n      line-height: 35px;\r\n      color: #1e106b;\r\n      // width: 150px;\r\n      // text-align: center;\r\n      .chrono-sub-header {\r\n        margin-left: 5px;\r\n        font-style: normal;\r\n        font-weight: bold;\r\n        font-size: 12px;\r\n        line-height: 35px;\r\n        color: #1e106b;\r\n      }\r\n      .chrono-list-icon {\r\n        height: 28px;\r\n        width: 28px;\r\n        border-radius: 50%;\r\n        color: #ffffff;\r\n      }\r\n    }\r\n\r\n    .chrono-content-items {\r\n      align-items: center;\r\n      list-style: none;\r\n      padding-left: 5px;\r\n      .chrono-item {\r\n        background: rgba(255, 255, 255, 0.5);\r\n        box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);\r\n        border-radius: 10px;\r\n        flex: none;\r\n        order: 1;\r\n        flex-grow: 0;\r\n        margin: 1px 0px;\r\n        font-weight: normal;\r\n        font-size: 14px;\r\n        line-height: 35px;\r\n        color: #000000;\r\n        padding: 2px;\r\n        .chrono-wrapper {\r\n          display: flex;\r\n          justify-content: space-between;\r\n        }\r\n        .chrono-label {\r\n          font-size: 13px;\r\n          color: #555555;\r\n          padding: 1px;\r\n          margin-left: 5px;\r\n        }\r\n        .chrono-value {\r\n          font-size: 13px;\r\n          color: black;\r\n          justify-content: flex-end;\r\n          margin-right: 8px;\r\n        }\r\n        .chrono-label-no-tooltip {\r\n          padding: 1px;\r\n          font-size: 13px;\r\n          color: #555555;\r\n          &:hover {\r\n            background: rgba(203, 249, 255, 0.5);\r\n            border: 1px dashed #009fe3;\r\n            box-sizing: border-box;\r\n            box-shadow: 0px 0px 23px rgba(2, 209, 255, 0.3);\r\n            border-radius: 2px 10px 10px 10px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .output-tab {\r\n    width: 100%;\r\n    padding: 0 !important;\r\n    text-align: center;\r\n    &-current {\r\n      .list-item-label {\r\n        border-bottom: 2px solid white;\r\n        padding-bottom: 2px;\r\n      }\r\n    }\r\n  }\r\n  .planner-tabs-wrapper {\r\n    width: 100%;\r\n    padding-top: 20px;\r\n    .MuiPaper-root {\r\n      box-shadow: none;\r\n      border-radius: 10px;\r\n    }\r\n    .planner-tab-panel {\r\n      margin-top: 8px;\r\n      border: 2px solid #ffffff;\r\n      border-radius: 10px;\r\n    }\r\n    .accordion-container {\r\n      .MuiAccordion-root {\r\n        background: #e0e0e0;\r\n      }\r\n      .MuiAccordionSummary-content {\r\n        margin: 4px 0;\r\n      }\r\n      .MuiAccordionSummary-root {\r\n        background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);\r\n        border: 2px solid #ffffff;\r\n        box-sizing: border-box;\r\n        box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);\r\n        border-radius: 10px;\r\n      }\r\n      .MuiAccordionDetails-root {\r\n        background: #e0e0e0;\r\n        padding: 8px 0;\r\n      }\r\n      .MuiSvgIcon-root {\r\n        color: #ffffff;\r\n      }\r\n    }\r\n    .tabs-container {\r\n      background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);\r\n      border-radius: 10px;\r\n      border: 2px solid #ffffff;\r\n      padding: 10px;\r\n      .MuiTab-root {\r\n        font-size: 12px;\r\n        // font-weight: bold;\r\n        color: white;\r\n        min-height: 30px;\r\n        height: 40px;\r\n      }\r\n      .Mui-selected {\r\n        font-weight: bold;\r\n        .MuiTouchRipple-root {\r\n          border-bottom: 2px solid #ffffff;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .form-container {\r\n    margin-left: 20px;\r\n    font-size: 12px;\r\n    padding: 10px 10px 10px 0;\r\n    .empty-grid {\r\n      border-left: 1px solid #ffffff;\r\n      &:last-child {\r\n        border-right: 1px solid #ffffff;\r\n      }\r\n    }\r\n    .fields-list-container {\r\n      display: flex;\r\n      list-style: none;\r\n      border-top: 1px solid #ffffff;\r\n      border-left: 1px solid #ffffff;\r\n      border-right: 1px solid #ffffff;\r\n      .fields-list-item {\r\n        // margin: 20px;\r\n        font-size: 12px;\r\n        text-align: center;\r\n        padding: 4px;\r\n        border-left: 1px solid #ffffff;\r\n        &:last-child {\r\n          border-right: 1px solid #ffffff;\r\n        }\r\n      }\r\n    }\r\n    .member-list-container {\r\n      // padding: 8px 0;\r\n      border-top: 1px solid #ffffff;\r\n      border-left: 1px solid #ffffff;\r\n      border-right: 1px solid #ffffff;\r\n      &:last-child {\r\n        border-bottom: 1px solid #ffffff;\r\n      }\r\n      .member-name {\r\n        font-weight: bold;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 8px;\r\n      }\r\n    }\r\n    .common-list-container {\r\n      border-bottom: 1px solid #ffffff;\r\n      .common-title {\r\n        padding: 8px;\r\n        font-weight: bold;\r\n        text-transform: uppercase;\r\n        font-size: 14px;\r\n      }\r\n    }\r\n    .planner {\r\n      &-input {\r\n        border-radius: 8px;\r\n        border: 0.5px solid #61b76e;\r\n        width: 100%;\r\n        height: 30px;\r\n        padding: 4px;\r\n\r\n        &:focus-visible {\r\n          outline: none;\r\n        }\r\n        &-hide {\r\n          opacity: 0;\r\n          height: 0;\r\n          width: 0;\r\n        }\r\n        &-show {\r\n          opacity: 1;\r\n          // max-height: 100%;\r\n          transition: all 0.3s ease-out;\r\n          -webkit-transition: all 0.3s ease-out;\r\n          // padding-top: 8px;\r\n          svg {\r\n            vertical-align: middle;\r\n          }\r\n          .select {\r\n            width: 80%;\r\n            border-color: #61b76e;\r\n            border-radius: 8px;\r\n            padding: 4px 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .planner-input-grid {\r\n      box-sizing: border-box;\r\n      box-shadow: -5px 4px 34px rgb(85 85 85 / 4%);\r\n      text-align: center;\r\n      border-left: 1px solid #ffffff;\r\n      &:last-child {\r\n        border-right: 1px solid #ffffff;\r\n      }\r\n      & > div {\r\n        padding: 8px;\r\n        margin-bottom: 8px;\r\n        border-radius: 10px;\r\n      }\r\n      .planner-label-disabled {\r\n        background-color: lightgray;\r\n      }\r\n      .error-text {\r\n        padding: 0;\r\n        margin: 0;\r\n        font-size: 10px;\r\n        color: red;\r\n      }\r\n      .error-field {\r\n        border-color: red;\r\n      }\r\n      // background: rgba(255, 255, 255, 0.3);\r\n      .input-value {\r\n        border-radius: 45px 50px 5px 50px;\r\n        color: white;\r\n        padding: 5px 5px;\r\n        background: linear-gradient(180.61deg, #32a3b2 29.35%, #61b76e 90.9%);\r\n        // width: auto;\r\n        font-size: 11px;\r\n        // height: 25px; //visit again\r\n        text-align: center;\r\n        margin-top: 8px;\r\n        margin-right: 5px;\r\n        margin-bottom: 5px;\r\n        display: inline;\r\n      }\r\n    }\r\n  }\r\n\r\n  .feedback-button {\r\n    padding: 4px 2px 0;\r\n    max-width: fit-content;\r\n    button {\r\n      background-color: #fbc02d;\r\n      padding: 5px;\r\n      border-radius: 4px;\r\n      height: 25px;\r\n      text-transform: none;\r\n      .MuiButton-startIcon {\r\n        margin: 0;\r\n      }\r\n      .MuiButton-iconSizeMedium {\r\n        margin-right: 4px;\r\n      }\r\n    }\r\n  }\r\n  .simulate-buttons {\r\n    padding: 4px 2px 0;\r\n    max-width: fit-content;\r\n    margin-top: 4px !important;\r\n    button {\r\n      background-color: #009fe3;\r\n      padding: 4px;\r\n      border-radius: 8px;\r\n      height: 25px;\r\n      color: white;\r\n      .MuiButton-startIcon {\r\n        margin: 0;\r\n      }\r\n      .MuiButton-iconSizeMedium {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n  .chrono-container {\r\n    width: 100%;\r\n    .chrono-tabs-wrapper {\r\n      background: linear-gradient(180deg, #16899d 0%, #6ccea6 100%);\r\n      border: 2px solid #ffffff;\r\n      box-sizing: border-box;\r\n      box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);\r\n      border-radius: 10px;\r\n      // width: 73%;\r\n      min-height: 62px;\r\n      margin: 15px 0px 0px 0px;\r\n      padding: 10px;\r\n    }\r\n    .chrono-parent-tab {\r\n      .MuiTabs-root {\r\n        border-bottom: 1px solid #e0e0e0;\r\n        min-height: 30px;\r\n      }\r\n      .MuiTab-root {\r\n        font-size: 12px;\r\n        // font-weight: bold;\r\n        color: white;\r\n        min-height: 30px;\r\n        height: 40px;\r\n      }\r\n      .Mui-selected {\r\n        font-weight: bold;\r\n        .MuiTouchRipple-root {\r\n          border-bottom: 2px solid #ffffff;\r\n        }\r\n      }\r\n    }\r\n    .chrono-sub-tab {\r\n      margin: 4px 16px;\r\n      .MuiTab-root {\r\n        font-size: 10px;\r\n        // font-weight: bold;\r\n        color: white;\r\n        min-height: 30px;\r\n        height: 40px;\r\n      }\r\n      .Mui-selected {\r\n        font-weight: bold;\r\n        .MuiTouchRipple-root {\r\n          border-bottom: 2px solid #ffffff;\r\n        }\r\n      }\r\n    }\r\n    .faq-wrapper {\r\n      border: 2px solid #ffffff;\r\n      box-sizing: border-box;\r\n      box-shadow: -5px 4px 34px rgb(85 85 85 / 4%);\r\n      border-radius: 10px;\r\n      // min-height: 62px;\r\n      margin: 15px 0px 0px 0px;\r\n      padding: 10px;\r\n      .chrono-tabs-container {\r\n        width: 100%;\r\n        border: 2px solid #ffffff;\r\n        border-radius: 10px;\r\n        padding: 0;\r\n        margin-top: 8px;\r\n      }\r\n      .item-width {\r\n        max-width: 100%;\r\n        flex-basis: 100%;\r\n      }\r\n      .planner-add-child {\r\n        margin: 8px 0;\r\n        min-height: 25px;\r\n        ul {\r\n          display: inline-flex;\r\n          list-style: none;\r\n          padding: 0 8px 0 0;\r\n          margin: 0;\r\n          & > li {\r\n            font-size: 12px;\r\n            font-weight: 600;\r\n            border-radius: 20px;\r\n            padding: 2px 2px 3px 2px;\r\n            background-color: #ffffff;\r\n            margin-right: 8px;\r\n            display: flex;\r\n            cursor: pointer;\r\n            .child-item {\r\n              margin-right: 14px;\r\n              .MuiRadio-root {\r\n                padding: 0;\r\n              }\r\n            }\r\n            .member-item {\r\n              padding: 1px 8px 0;\r\n              cursor: pointer;\r\n              label {\r\n                cursor: pointer;\r\n              }\r\n              .member-editable-label {\r\n                font-size: 12px;\r\n                padding-top: 4px;\r\n              }\r\n              .editing-text {\r\n                border: 1px solid white;\r\n                border-radius: 8px;\r\n                padding: 2px 4px;\r\n                outline: none;\r\n              }\r\n            }\r\n          }\r\n          .selected-child {\r\n            background-color: #009fe3;\r\n            label {\r\n              color: white;\r\n            }\r\n            svg {\r\n              color: white;\r\n            }\r\n            .member-editable-label {\r\n              color: white;\r\n            }\r\n          }\r\n        }\r\n      }\r\n      .faq-container {\r\n        box-sizing: border-box;\r\n        box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);\r\n        border-radius: 5px;\r\n        padding: 5px;\r\n        .faq-content-items {\r\n          .faq-item {\r\n            background: rgba(255, 255, 255, 0.5);\r\n            box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);\r\n            border-radius: 10px;\r\n            flex: none;\r\n            order: 1;\r\n            flex-grow: 0;\r\n            margin: 1px 0px;\r\n            font-weight: normal;\r\n            font-size: 14px;\r\n            line-height: 25px;\r\n            color: #000000;\r\n            padding: 2px;\r\n            .faq-question {\r\n              font-size: 13px;\r\n              color: #555555;\r\n            }\r\n            .faq-answer {\r\n              font-size: 13px;\r\n              color: black;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
